import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { ServiceTypeEnum, RootMenuEnum, MenuPermissionActionEnum, MenuPermissionConfig } from 'app/models';
import { AppDataService } from 'app/services';
import { MenuHomeEnum } from 'app/components/home';
import { AppComponent } from 'app/app.component';

//enum MenuEnum {
//    Dashboard = 0,
//    Application = 1,
//    Training = 2,
//    Activation = 3,
//    Users = 5,
//    Transactions = 6,
//    Drivers = 7,
//    Accounting = 8,
//    Settings = 9,
//    DriverTraining = 10,
//    Disciplinary = 12,
//    DriverCenters = 13
//}

@Component({
    selector: 'home-root',
    templateUrl: './home-root.component.html',
    styleUrls: ['./home-root.component.scss',
        '../../../../styles/menu-sidebar.scss'
    ],
})
export class HomeRootComponent implements OnInit {

    public serviceTypeId!: ServiceTypeEnum;

    @Output() public OnBackToDashboardHandle = new EventEmitter<any>();

    constructor(public appData: AppDataService, public app: AppComponent) { }

    public menuPermissionConfig = MenuPermissionConfig;
    public menuPermissionActionEnum = MenuPermissionActionEnum;

    public menuPermissionActive!: string;

    public activeRootMenu: RootMenuEnum | null = null;

    public menuEnum = MenuHomeEnum;
    public activeMenu: MenuHomeEnum = MenuHomeEnum.Dashboard;

    ngOnInit(): void {
        this.activeRootMenu = this.appData.activeRootMenu;
    }

    public clickMenu(menuPermissionActive: string, menu: MenuHomeEnum) {
        this.menuPermissionActive = menuPermissionActive;
        this.activeMenu = menu;
    }


}
